import $ from "jquery";
import React, { useEffect, useState } from "react";

const NotFound = (props) => {

  return (
  	<div>
			<h2>404 - Page Not Found</h2>
			<p>The page you are looking for does not exist.</p>
			<p>Go back to <a href="/">Home</a></p>
  	</div>
  );
};

export default NotFound;
